import { dataIdCardSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdCardSolid = /*#__PURE__*/createIcon(dataIdCardSolid)
export default IconIdCardSolid
